import { forwardRef, useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import cn from "../../utils/cn";

const PasswordInput = forwardRef(({ label, labelClassName, type, className, errorState, isPasswordToggle, required, ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative w-full">
      <label className={cn("block text-md font-bold text-black mb-1", labelClassName)}>
        {label}
        {required && <span className="text-accent-red" aria-hidden="true"> *</span>}
      </label>
      <input
        type={showPassword ? "text" : "password"}
        required={required}
        {...props}
        className={
          cn(
            "appearance-none block w-full max-sm:pl-3 p-4 pr-10 border border-accent-gray-border rounded-md bg-white text-black placeholder-[#585858] focus:outline-none focus:shadow-outline-blue focus:border-accent-blue transition duration-150 ease-in-out text-md font-medium",
            className
          )}
        ref={ref}
      />
      {isPasswordToggle &&
        <button
          type="button"
          aria-label="View Password"
          className={"absolute right-2 top-14 transform -translate-y-1/2 text-accent-gray"}
          onClick={() => isPasswordToggle && setShowPassword((prev) => !prev)}
        >
          {showPassword ? <EyeIcon className="w-6 h-6" /> : <EyeSlashIcon className="w-6 h-6" />}
        </button>}
      {errorState && (
        <p className="text-accent-red text-sm mt-1">{errorState}</p>
      )}
    </div>
  );
})

export default PasswordInput;
